import { render, staticRenderFns } from "./xlpage.vue?vue&type=template&id=66650707&scoped=true"
import script from "./xlpage.vue?vue&type=script&lang=js"
export * from "./xlpage.vue?vue&type=script&lang=js"
import style0 from "./xlpage.vue?vue&type=style&index=0&id=66650707&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66650707",
  null
  
)

export default component.exports